import { render, staticRenderFns } from "./GavelIcon.vue?vue&type=template&id=53431796"
import script from "./GavelIcon.vue?vue&type=script&lang=ts"
export * from "./GavelIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports